import base from '@/__vue2stone/service/wasaapi/v1/__base';
import time from '@/service/base/time';
import store from '@/store';
import S_base from '@/service/api/v1/__base';
import H_file from '@/helpers/file';
import H_change from '@/helpers/change';

export default {
  async createChange(factoryId, data) {
    //create change
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'change',
      data: _data,
    });
    return res;
  },
  async deleteChange(changeId, params) {
    //delete change
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.delete({
      modelName: 'change',
      modelId: changeId,
      params: _params,
    });
    return res;
  },
  async updateChange(changeId, data) {
    //update change
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'change',
      modelId: changeId,
      data: _data,
    });
    return res;
  },
  async changeUpdate(changeVersionId, data) {
    //update change version
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'change_version',
      modelId: changeVersionId,
      data: _data,
    });
    return res;
  },
  async createChangeVersion(data, changeId) {
    //建立變動版本
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.create({
      parentName: 'change',
      parentId: changeId,
      modelName: 'change_version',
      data: _data,
    });
    return res;
  },
  async changeVersionUpdate(changeId, data) {
    //update change version
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await base.update({
      modelName: 'change_version',
      modelId: changeId,
      data: _data,
    });
    return res;
  },
  async getChangeList(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'change',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getChangePrintList(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'change_print/index',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async getExpiredChangeList(factoryId, params, type = 'factory') {
    const currentFactory = store.state.app.factory;
    let _params = {
      factory: currentFactory.id,
      ...params,
    };
    if (type === 'organization') {
      _params.organization = currentFactory.id;
      delete _params.factory;
    }
    const res = await base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'change/expired',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getChangeVersionList(changeId, params) {
    //取得change version 歷史記錄(show)
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.index({
      parentName: 'change',
      parentId: changeId,
      modelName: 'change_version',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async getChangeContent(changeId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'change',
      modelId: changeId,
      params: _params,
    });
    return res;
  },
  async getChangeVersionContent(changeVersionId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await base.show({
      modelName: 'change_version',
      modelId: changeVersionId,
      params: _params,
    });
    return res;
  },
  async stopChange(factoryId, changeId) {
    //中止變動
    const res = await S_base.create({
      url: `factory/${factoryId}/change/${changeId}/stop`,
    });
    return res;
  },
  async restartChange(factoryId, changeId) {
    //重啟變動
    const res = await S_base.create({
      url: `factory/${factoryId}/change/${changeId}/restart`,
    });
    return res;
  },
  async startChange(factoryId, changeId) {
    //啟動變動
    const res = await S_base.create({
      url: `factory/${factoryId}/change/${changeId}/start`,
    });
    return res;
  },
  setChangeData(change) {
    //update 預先填入的變動內容
    const data = {
      id: change.id,
      name: change.name,
      changeStatus: change.change_status,
      owner: change.last_version ? change.last_version.owner.id : null,
      ownerValue: change.last_version ? change.last_version.owner : {},
      evaluateExpiredAt: change.last_version
        ? time.getTimeFormat(change.last_version.expired_date, 'YYYY-MM-DD')
        : '',
      attaches: change.last_version
        ? H_file.setShowInModule(change.last_version.file_attaches)
        : [],
      version: change.versions_number,
      versionId: change.last_version.id,
    };
    return data;
  },
  getChangeData(data) {
    //show
    const _systemSubclasses = H_change.getVersionDomainChips(data.last_version);
    return {
      id: data.id,
      versionId: data.last_version.id,
      name: data.name,
      version: `ver. ${data.versions_number}`,
      condition: data.change_status,
      owner: data.last_version.owner,
      date: time.getTimeFormat(data.created_at, 'YYYY-MM-DD'), //建立日期
      evaluateExpiredAt: time.getTimeFormat(
        data.last_version.expired_date,
        'YYYY-MM-DD',
      ), //到期日
      systemSubclasses: _systemSubclasses,
      attaches: H_file.setShowInModule(data.last_version.file_attaches),
      creator: data.created_user,
    };
  },
  getChangeDataForUpdate(data) {
    //update
    return {
      id: data.id,
      versionId: data.last_version.id,
      name: data.name,
      attaches: H_file.setShowInModule(data.last_version.file_attaches),
      owner: data.last_version.owner.id,
      ownerValue: data.last_version.owner,
      evaluateExpiredAt: time.getTimeFormat(
        data.last_version.expired_date,
        'YYYY-MM-DD',
      ),
      version: data.versions_number,
    };
  },
  getChangeVersionData(data) {
    return {
      id: data.id,
      version: 'ver.' + data.version_number,
      owner: data.owner,
      date: time.getTimeFormat(data.update_at, 'YYYY-MM-DD'), //建立日期
      evaluateExpiredAt: time.getTimeFormat(data.expired_date, 'YYYY-MM-DD'), //到期日
      systemSubclasses: H_change.getVersionDomainChips(data),
      attaches: H_file.setShowInModule(data.file_attaches),
    };
  },
  //轉換change+version格式 用於作業
  getChangeDataAssignment(change) {
    return {
      id: change.id,
      name: change.name,
      owner: {
        name: change.last_version.owner ? change.last_version.owner.name : null,
        avatar: change.last_version.owner
          ? change.last_version.owner.avatar
          : null,
      },
      version:
        change.last_version && change.last_version.version_number
          ? `ver${change.last_version.version_number}.`
          : null,
      lastVersionId: change.last_version.id,
      versions: change.last_versions,
      evaluateExpiredAt: time.getTimeFormat(
        change.last_version.expired_date,
        'YYYY-MM-DD',
      ),
      attaches: H_file.setShowInModule(change.last_version.file_attaches),
    };
  },
  getChangeChangedRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        date: time.getTimeFormat(item.created_at, 'YYYY-MM-DD'),
        owner: item.last_version.owner
          ? item.last_version.owner
          : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/change-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  getChangeExpiredRowData(factoryId, list) {
    if (!list || list.length === 0) return [];
    const _list = list.map((item) => {
      return {
        id: item.id,
        name: item.name,
        date: time.getTimeFormat(item.last_version.expired_date, 'YYYY-MM-DD'),
        owner: item.last_version.owner
          ? item.last_version.owner
          : { name: '', avatar: '' },
        icon: {
          icon: 'icon-arrow-right',
          path: `/factory/${factoryId}/change-content/${item.id}`,
        },
      };
    });
    return _list;
  },
  async tabIndex(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params
    };
    const res = await base.index({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'change/tab_index',
      params: _params,
    });
    return res;
  },
};
